import styled from 'styled-components/macro'

export const Wrap = styled.div`
  position: relative;
  margin: auto;
  padding: 4.6rem 0;
  width: 100%;
  max-width: 32rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    padding: 6rem 0;
    max-width: 57.2rem;
  `};
`

export const IconWrap = styled.div`
  margin: 0 0 3rem;
  width: 12rem;
  color: ${(props) => props.theme.color.textHint};
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    width: 20.4rem;
  `};
`

export const Title = styled.h2`
  margin: 0 0 0.8rem;
  font-weight: ${(props) => props.theme.font.weight.bold};
  font-size: 2rem;
  line-height: 1.44;
  color: ${(props) => props.theme.color.text};
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    font-size: 2.4rem;
    line-height: 1.53;
  `};
`

export const Text = styled.p`
  margin: 0 0 4.4rem;
  font-size: 1.4rem;
  line-height: 1.33;
  text-align: center;
  color: ${(props) => props.theme.color.textSecondary};
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    margin: 0 0 2.6rem;
    font-size: 1.6rem;
    line-height: 1.43;
  `};
  ${(props) => props.theme.breakpoints.greaterThan('md')`
    margin: 0 0 3.2rem;
  `};
`
